export default "__VITE_ASSET__ZcZid2vt__"